import { MutationTree } from "vuex";

import { State } from "./state";
import { AuthMutationTypes as MutationTypes } from "./mutation-types";
import { company } from "@/store/@types";
export type Mutations<S = State> = {
  [MutationTypes.SET_USER](state: S, payload: Array<any>): void;
  [MutationTypes.SET_PARTNER](state: S, payload: any): void;
  [MutationTypes.SET_COMPANY](state: S, payload: company): void;
  [MutationTypes.SET_SITE](state: S, payload: any): void;
  [MutationTypes.SET_GROUP](state: S, payload: any): void;
  [MutationTypes.SET_AGMS_SITE](state: S, payload: any): void;
  [MutationTypes.SET_AGMS_GROUP](state: S, payload: any): void;
  [MutationTypes.SET_AGMS_TEMPLATE](state: S, payload: any): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_USER](state, payload: Array<any>) {
    state.user = payload;
  },
  [MutationTypes.SET_PARTNER](state, payload: any) {
    state.partner = payload;
  },
  [MutationTypes.SET_COMPANY](state, payload: company) {
    state.company = payload;
  },
  [MutationTypes.SET_SITE](state, payload: any) {
    state.site = payload;
  },
  [MutationTypes.SET_GROUP](state, payload: any) {
    state.group = payload;
  },
  [MutationTypes.SET_AGMS_SITE](state, payload: any) {
    state.agmsSite = payload;
  },
  [MutationTypes.SET_AGMS_GROUP](state, payload: any) {
    state.agmsGroup = payload;
  },
  [MutationTypes.SET_AGMS_TEMPLATE](state, payload: any) {
    state.agmsTemplate = payload;
  },
};
